import { Image } from 'react-konva'

type Props = {
  image: string
  x: number
  y: number
  width: number
  height: number
}
const KonvaImage = ({ image, x, y, width, height }: Props) => {
  const img = new window.Image()
  img.src = image

  return <Image image={img} x={x} y={y} width={width} height={height} />
}

export default KonvaImage
